import { render } from "./MembersFamilyView.vue?vue&type=template&id=37c6f1b5&scoped=true"
import script from "./MembersFamilyView.vue?vue&type=script&lang=js"
export * from "./MembersFamilyView.vue?vue&type=script&lang=js"

import "./MembersFamilyView.vue?vue&type=style&index=0&id=37c6f1b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c6f1b5"]])

export default __exports__